import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269","key":"svg-0"}],["path",{"d":"M12 20v-9","key":"svg-1"}]]

const IconCellSignal3 = createReactComponent('outline', 'cell-signal-3', 'CellSignal3', __iconNode);

export default IconCellSignal3;